module.exports = __webpack_public_path__ + "img/Busy_Corner@1x.1f718075.png";